import { DetalleTransaccionalDelCaso } from "../components/deteccionyanalisisfraudes/detalle-transaccional-del-caso/detalle-transaccional-del-caso.component";
import { DeterminarProcedenciaDelCaso } from "../components/deteccionyanalisisfraudes/determinar-procedencia-del-caso/determinar-procedencia-del-caso.component";
import {ReclamosMediosMagneticos} from '../components/deteccionyanalisisfraudes/reclamos/reclamos-medios-magneticos/reclamos-medios-magneticos.component';
import {ReclamosMediosNOMagneticos} from '../components/deteccionyanalisisfraudes/reclamos/reclamos-medios-no-magneticos/reclamos-medios-no-magneticos.component';
import { DeterminarProcedenciaFraudeComponent } from "../components/gestion-administrativa-fraude/determinar-procedencia-fraude/determinar-procedencia-fraude.component";

export const COMPONENTS = [
  {
    name: 'Determinar Procedencia del Caso',
    value: 'DeterminarProcedenciaDelCaso',
    component: DeterminarProcedenciaDelCaso,
    caso: 'Detección y Análisis de Fraudes'
  },
  {
    name: 'Detalle Transaccional del Caso',
    value: 'DetalleTransaccionalDelCaso',
    component: DetalleTransaccionalDelCaso,
    caso: 'Detección y Análisis de Fraudes'
  },
  {
    name: 'Reclamos Medios Magnéticos',
    value: 'ReclamosMediosMagneticos',
    component: ReclamosMediosMagneticos,
    caso: 'Detección y Análisis de Fraudes'
  },
  {
    name: 'Reclamos Medios NO Magnéticos',
    value: 'ReclamosMediosNOMagneticos',
    component: ReclamosMediosNOMagneticos,
    caso: 'Detección y Análisis de Fraudes'
  },
  //Gestion adm fraudes
  {
    name: 'Determinar Procedencia del Fraude',
    value: 'DeterminarProcedenciaFraude',
    component: DeterminarProcedenciaFraudeComponent,
    caso: 'Gestión Administrativa de Fraudes'
  },
]
